import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import Marquee from 'react-fast-marquee'

import styled from '@emotion/styled'
import { breakpoints } from '~/utils/styles'

import { Grid, Product, Title } from './styles'
import { Img } from '~/utils/styles'
import {
  formatTitle,
  getBackgroundColor,
  getReviewCount,
} from '~/utils/helpers'
import Heading from '~/components/Heading'
import QuickAdd from '~/components/QuickAdd'
import StarRating from '~/components/StarRating'
import Circle from '~/components/Circle'
import Wiggle from '~/icons/Wiggle'

const Wrapper = styled.div`
  margin: 0 auto;
  position: relative;
  /* background: #dcd0af; */
  background: #fdf3e3;

  a {
    color: currentColor;
    text-decoration: none;
  }
`

const TasterWrap = styled.div`
  margin: 0 auto;
  padding: 100px 0;
  max-width: 1100px;
  z-index: 1;
  position: relative;
  display: flex;
  justifty-content: center;
  align-items: center;

  @media (max-width: ${breakpoints.s}px) {
    width: 100%;
    padding: 0 0 40px 0;
    flex-wrap: wrap;
    flex-direction: column-reverse;
  }
`

const TasterColumn = styled.div`
  width: 50%;
  text-align: center;
  font-size: 18px;
  box-sizing: border-box;

  @media (max-width: ${breakpoints.s}px) {
    width: 100%;
    padding: 0 20px;
  }
`

const MarqueeContainer = styled.div`
  width: 100%;
  background: #def154;
  font-family: 'SohneBreit';
  font-weight: 400;
  padding: 30px 0;
  // color: white;

  font-size: 28px;
  letter-spacing: 2px;
  line-height: 40px;

  svg {
    height: 30px;
    width: 60px;
  }

  span {
    margin: 0 40px;
    display: inline-flex;
  }

  @media (max-width: ${breakpoints.s}px) {
    font-size: 10px;
    line-height: 30px;
  }
`

const ProductGrid = () => {
  const { allShopifyProduct } = useStaticQuery(
    graphql`
      query {
        allShopifyProduct(sort: { fields: [createdAt], order: DESC }) {
          edges {
            node {
              id
              title
              handle
              createdAt
              images {
                id
                originalSrc
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 910) {
                      ...GatsbyImageSharpFluid_withWebp_tracedSVG
                    }
                  }
                }
              }
              tags
              variants {
                id
                title
                price
                availableForSale
                shopifyId
                selectedOptions {
                  name
                  value
                }
              }
            }
          }
        }
      }
    `
  )

  const mainFlavours = allShopifyProduct.edges.filter(e => {
    return (
      e.node.handle !== 'taster-pack' &&
      !e.node.tags.includes('wholesale') &&
      e.node.tags.includes('main-product')
    )
  })
  const taster = allShopifyProduct.edges.filter(e => {
    return e.node.handle === 'taster-pack'
  })

  return (
    <>
      <Wrapper id="product-grid">
        <Grid>
          {mainFlavours ? (
            mainFlavours.map(
              ({
                node: {
                  id,
                  handle,
                  title,
                  images: [firstImage],
                  variants,
                  tags,
                },
              }) => {
                return (
                  <Product key={id} className="product">
                    <Link to={`/products/${handle}/`}>
                      <div
                        style={{
                          background: getBackgroundColor(handle),
                          display: 'flex',
                          justifyContent: 'center',
                          position: 'relative',
                          marginBottom: 30,
                        }}
                      >
                        <Circle handle={handle} />
                        {firstImage && firstImage.localFile && (
                          <Img
                            fluid={firstImage.localFile.childImageSharp.fluid}
                            alt={handle}
                            style={{ width: '100%', margin: 0 }}
                          />
                        )}
                      </div>

                      <Title
                        dangerouslySetInnerHTML={{ __html: formatTitle(title) }}
                      />
                    </Link>

                    <QuickAdd variants={variants} handle={handle} />
                    <div
                      style={{
                        margin: '20px 0',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <StarRating>{getReviewCount(handle)} reviews</StarRating>
                    </div>
                  </Product>
                )
              }
            )
          ) : (
            <p>No Products found!</p>
          )}
        </Grid>

        {taster
          ? taster.map(
              ({
                node: {
                  id,
                  handle,
                  title,
                  images: [firstImage],
                  variants,
                },
              }) => {
                return (
                  <TasterWrap key={id} className="product">
                    <TasterColumn>
                      <Link to={`/products/${handle}/`}>
                        <Heading mobileFontSize="26px">
                          <span>Taster</span> Pack
                        </Heading>
                      </Link>
                      <p>
                        Choices, schmoices - life’s full of them so here’s a
                        nice easy one. If you can’t pick a flavour, try a mixed
                        pack instead - a taster of every flavour we offer so you
                        can pick your favourite
                      </p>
                      <QuickAdd variants={variants} handle={handle} />
                      <div
                        style={{
                          margin: '20px 0',
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <StarRating>
                          {getReviewCount(handle)} reviews
                        </StarRating>
                      </div>
                    </TasterColumn>
                    <TasterColumn>
                      <Link to={`/products/${handle}/`}>
                        <div
                          style={{
                            // background: getBackgroundColor(handle),
                            display: 'flex',
                            justifyContent: 'center',
                            position: 'relative',
                          }}
                        >
                          {firstImage && firstImage.localFile && (
                            <Img
                              fluid={firstImage.localFile.childImageSharp.fluid}
                              alt={handle}
                              style={{ width: '100%', margin: 0 }}
                            />
                          )}
                          <Circle handle={handle} />
                        </div>
                      </Link>
                    </TasterColumn>
                  </TasterWrap>
                )
              }
            )
          : null}
      </Wrapper>
    </>
  )
}

export default ProductGrid
